import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue"
import {
  ConsultantAvailability,
  ConsultantProfileFragmentFragment,
  UpdateConsultantAvailabilityMutation,
  UpdateConsultantAvailabilityMutationMutation,
  PermissionEnum,
} from "@/gql"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { useAuth } from "@/store/auth/useAuth"
import Icon from "@/components/widgets/icons/Icon.vue"
import { ConsultantAvailabilityStatuses } from "@/constants"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultantProfileSummary',
  props: {
    consultantProfile: null
  },
  setup(__props: any) {

const props = __props as {
  consultantProfile: ConsultantProfileFragmentFragment
}



const { mutate } = useMutation()
const { addSuccess, addMutationError, addError } = useNotification()
const { can } = useAuth()

const showEditAvailabilityForm = ref(false)
const loading = ref(false)

const form = ref<{
  availability: ConsultantAvailability
  availabilityReason: string
}>({
  availability: props.consultantProfile.availability || ConsultantAvailability.NotAvailable,
  availabilityReason: "",
})

const availabilityColor = computed(() => {
  switch (props.consultantProfile?.availability) {
    case ConsultantAvailability.AvailableFullTime:
      return "#219653"
    case ConsultantAvailability.AvailablePartTime:
      return "orange"
    case ConsultantAvailability.NotAvailable:
    default:
      return "red"
  }
})

const availabilityStatuses = computed(() => ConsultantAvailabilityStatuses)

const availability = computed(() => {
  return getAvailabilityStatus(form.value.availability)
})

const getAvailabilityStatus = (value: ConsultantAvailability) => {
  return (
    availabilityStatuses.value.find((status) => status.value === value) ||
    availabilityStatuses.value[2]
  )
}

const showUnAvailabilityReasonForm = () => {
  showEditAvailabilityForm.value = true
}

const onAvailabilityChange = async (value: ConsultantAvailability) => {
  form.value.availability = value

  if (value === ConsultantAvailability.NotAvailable) {
    return showUnAvailabilityReasonForm()
  }

  await updateAvailability()
}

const updateAvailability = async () => {
  if (!props.consultantProfile) return

  if (!form.value.availability) {
    addError("Availability cannot be empty")
    return
  }
  loading.value = true

  const result = await mutate<UpdateConsultantAvailabilityMutationMutation>({
    mutation: UpdateConsultantAvailabilityMutation,
    variables: {
      availability: form.value.availability,
      availabilityReason: form.value.availabilityReason || undefined,
      consultantId: can(PermissionEnum.EditTalent) ? props.consultantProfile.id : undefined,
    },
    done: () => {
      loading.value = false
    },
  })

  if (result && result.data && result.data.updateConsultantAvailability) {
    const error = result.data.updateConsultantAvailability.error

    if (error) {
      addMutationError(error)
    } else {
      if (result.data.updateConsultantAvailability.consultant?.id) {
        showEditAvailabilityForm.value = false
        addSuccess("Your availability has been updated")
      }
    }
  }
}

const consultantInitials = computed(() => {
  return `${props.consultantProfile?.firstName?.[0]}${props.consultantProfile.lastName?.[0]}`
})

const onClose = () => {
  showEditAvailabilityForm.value = false
  form.value.availabilityReason = ""
}

return { __sfc: true,props, mutate, addSuccess, addMutationError, addError, can, showEditAvailabilityForm, loading, form, availabilityColor, availabilityStatuses, availability, getAvailabilityStatus, showUnAvailabilityReasonForm, onAvailabilityChange, updateAvailability, consultantInitials, onClose, Icon }
}

})